// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user__image[data-v-3429d95c]{display:flex;justify-content:center;margin-top:32px}.user__image img[data-v-3429d95c]{width:140px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
